import { createReducer } from 'redux-create-reducer'
import type { SubscriptionData } from 'types/subscription'
import {
  SUBSCRIPTION_LOAD,
  SUBSCRIPTION_LOAD_FAIL,
  SUBSCRIPTION_LOAD_SUCCESS,
} from '@disco/constants/ActionTypes'
const initialState = {
  loading: false,
  loaded: false,
  error: null,
}
export type State = SubscriptionData
export const subscriptionReducer = createReducer<State, any>(initialState, {
  [SUBSCRIPTION_LOAD](_state) {
    return {
      ..._state,
      loading: true,
      loaded: false,
      error: null,
    }
  },

  [SUBSCRIPTION_LOAD_SUCCESS](
    _state,
    action: {
      type: string
      result: SubscriptionData
    },
  ) {
    // result spread first so these explicit fields win; explicit-before-spread triggers TS2783.
    // loading/loaded/error are client-side only — the API returns SubscriptionChargifyData which never includes them.
    return {
      ...action.result,
      loading: false,
      loaded: true,
      error: null,
    }
  },

  [SUBSCRIPTION_LOAD_FAIL](_state, action) {
    return {
      loading: false,
      loaded: false,
      error: action.error,
    }
  },
})
